import { createRouter, createWebHistory } from 'vue-router'
import { getItem } from '@/utils/storage'
import StockListView from '../views/StockListView.vue'
import StockIndicatorView from '../views/StockIndicatorView.vue'
import StockBasicView from '../views/StockBasicView.vue'
import StockKLineView from '../views/StockKLineView.vue'
import TrendChannelView from '../views/TrendChannelView.vue'
import ChgDistributionView from '../views/ChgDistributionView.vue'
import LimitStocksView from '../views/LimitStocksView.vue'
import PortfolioView from '../views/PortfolioView.vue'
import BacktestView from '../views/BacktestView.vue'
import KLineTrainView from '../views/KLineTrainView.vue'
import MainwaveView from '../views/MainwaveView.vue'
import MainwavePickerView from '../views/MainwavePickerView.vue'
import MainwaveScorerView from '../views/MainwaveScorerView.vue'
import ShortTermBasePoolView from '../views/ShortTermBasePoolView.vue'
import TradingStrategyView from '../views/TradingStrategyView.vue'
import ShortTermPctChgDistributionView from '../views/ShortTermPctChgDistributionView.vue'
import VolatilityUniverseView from '../views/VolatilityUniverseView.vue'
import StockFinancialView from '../views/StockFinancialView.vue'
import FinancialListView from '../views/FinancialListView.vue'
import SyncJobLogView from '../views/SyncJobLogView.vue'
import AgentView from '../views/AgentView.vue'
import BoardListView from '../views/BoardListView.vue'
import BoardDetailView from '../views/BoardDetailView.vue'
import SystemLogView from '../views/SystemLogView.vue'
import GalleryView from '../views/GalleryView.vue'

const routes = [
  {
    path: '/',
    name: 'gallery',
    component: GalleryView,
    meta: {
      title: '图库',
      nav: true,
      navOrder: 5,
      section: '主页',
      hero: {
        number: '8',
        section: '主页',
        title: '图库管理'
      }
    }
  },
  {
    path: '/stock-basic',
    name: 'stock-basic',
    component: StockBasicView,
    meta: {
      title: '股票基本信息',
      nav: true,
      navOrder: 10,
      group: '股票基本信息',
      hero: {
        number: '1.1',
        section: '基本面',
        description: 'A 股标的索引：代码、名称、行业、地域、上市板块与时间。其他章节的数据均以此为锚点。',
        meta: '底层维度'
      }
    }
  },
  {
    path: '/financial',
    name: 'financial-list',
    component: FinancialListView,
    meta: {
      title: '财务指标',
      nav: true,
      navOrder: 11,
      group: '股票基本信息',
      hero: {
        number: '1.2',
        section: '基本面',
        description: '沪深主板核心财务数据一览：盈利能力、成长性与偿债能力。',
        meta: '财务维度'
      }
    }
  },
  {
    path: '/daily/basic',
    name: 'stock-list',
    component: StockListView,
    meta: {
      title: '基本数据',
      nav: true,
      navOrder: 20,
      group: '股票日线数据',
      hero: {
        number: '2.1',
        section: '股票日线数据',
        description: '按交易日期检索全市场基础日线行情：开高低收、涨跌、成交。指标列在「指标数据」中独立维护。',
        meta: '行情快照'
      }
    }
  },
  {
    path: '/daily/indicator',
    name: 'stock-indicator',
    component: StockIndicatorView,
    meta: {
      title: '指标数据',
      nav: true,
      navOrder: 21,
      group: '股票日线数据',
      hero: {
        number: '2.2',
        section: '股票日线数据',
        description: '均线、均量、均换手等衍生指标。基于已同步的日线行情批量计算并落库。',
        meta: '衍生指标'
      }
    }
  },
  {
    path: '/chg-distribution',
    name: 'chg-distribution',
    component: ChgDistributionView,
    meta: {
      title: '涨幅分布统计',
      nav: true,
      navOrder: 30,
      group: '市场情绪',
      hero: {
        number: '3.1',
        section: '市场情绪',
        description: '按日期区间统计每日市场涨跌家数及强势标的占比，识别市场强弱节奏。点击柱状图查看当日板块分布。',
        meta: '占比分布'
      }
    }
  },
  {
    path: '/limit-up',
    name: 'limit-up',
    component: LimitStocksView,
    meta: {
      title: '涨停统计',
      nav: true,
      navOrder: 31,
      group: '市场情绪',
      limitType: 'up',
      hero: {
        number: '3.2',
        section: '市场情绪',
        description: '按交易日查看全市场涨停个股，按连板高度分组，识别接力情绪。',
        meta: '连板分组'
      }
    }
  },
  {
    path: '/limit-down',
    name: 'limit-down',
    component: LimitStocksView,
    meta: {
      title: '跌停统计',
      nav: true,
      navOrder: 32,
      group: '市场情绪',
      limitType: 'down',
      hero: {
        number: '3.3',
        section: '市场情绪',
        description: '按交易日查看全市场跌停个股，识别恐慌与情绪最弱方向。',
        meta: '跌停'
      }
    }
  },
  {
    path: '/limit-stocks',
    redirect: '/limit-up'
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: PortfolioView,
    meta: {
      title: '持仓管理',
      nav: true,
      navOrder: 40,
      section: '资产',
      hero: {
        number: '10',
        section: '资产',
        description: '录入买入与卖出记录，自动计算每日盈亏与总收益，支持多维度图表分析。',
        meta: '个人持仓'
      }
    }
  },
  {
    path: '/backtest',
    name: 'backtest',
    component: BacktestView,
    meta: {
      title: '回测',
      nav: true,
      navOrder: 41,
      section: '资产',
      hero: {
        number: '11',
        section: '资产',
        description: '选择起始日期，让 AI 在每个交易日基于历史 K 线决定买卖，支持手动步进与自动运行。',
        meta: 'AI 回测'
      }
    }
  },
  {
    path: '/backtest/train',
    name: 'backtest-train',
    component: KLineTrainView,
    meta: {
      title: '裸K线训练',
      nav: true,
      navOrder: 42,
      section: '资产',
      hero: {
        number: '12',
        section: '资产',
        description: '随机抽取历史K线，隐藏未来走势，练习只看裸K线的买卖判断。最后显示日期之后保留至少 30 个交易日。',
        meta: '裸K线训练'
      }
    }
  },
  {
    path: '/mainwave/picker',
    name: 'mainwave-picker',
    component: MainwavePickerView,
    meta: {
      title: '选股',
      nav: true,
      navOrder: 50,
      group: '主升浪',
      hero: {
        number: '4.1',
        section: '选股策略',
        title: '主升浪选股',
        description: '基于交易日期筛选符合主升浪门槛的主板标的：流通市值≥200亿、股价≤300元、10日换手≥2%、10日成交额≥2亿。双击行跳转K线图。',
        meta: '选股门槛'
      }
    }
  },
  {
    path: '/mainwave/scorer',
    name: 'mainwave-scorer',
    component: MainwaveScorerView,
    meta: {
      title: '评分',
      nav: true,
      navOrder: 51,
      group: '主升浪',
      hero: {
        number: '4.2',
        section: '选股策略',
        title: '主升浪评分',
        description: '对主升浪选股结果进行多维度评分：趋势形态、方向分散、板块强度、业绩质量、市值流动性、催化剂。满分100分，60分及格，80分强烈推荐。',
        meta: '评分体系'
      }
    }
  },
  {
    path: '/mainwave/group',
    name: 'mainwave-group',
    component: MainwaveView,
    meta: {
      title: '分组',
      nav: true,
      navOrder: 52,
      group: '主升浪',
      hero: {
        number: '4.3',
        section: '选股策略',
        title: '主升浪分组',
        description: '基于交易日期筛选符合主升浪门槛的主板标的，按趋势强度分层分组。双击行跳转K线图。',
        meta: '趋势分层'
      }
    }
  },
  {
    path: '/mainwave',
    redirect: '/mainwave/picker'
  },
  {
    path: '/mainwave-picker',
    redirect: '/mainwave/picker'
  },
  {
    path: '/mainwave-scorer',
    redirect: '/mainwave/scorer'
  },
  {
    path: '/short-term/strategy',
    name: 'trading-strategy',
    component: TradingStrategyView,
    meta: {
      title: '四层策略池',
      nav: true,
      navOrder: 61.5,
      navPlacement: 'primary',
      section: '交易策略',
      hero: {
        number: '6',
        section: '交易策略',
        title: '四层策略池',
        description: '按四层条件筛出最终形态，按连续阳线天数分组；组内综合评分排名，默认给出前 3 只买入候选。',
        meta: '连阳分组 · 评分'
      }
    }
  },
  {
    path: '/short-term/base-pool',
    name: 'short-term-base-pool',
    component: ShortTermBasePoolView,
    meta: {
      title: '基础池',
      nav: true,
      navOrder: 60,
      group: '短线选股策略',
      hero: {
        number: '5.1',
        section: '短线选股策略',
        title: '短线基础池',
        description: '短线策略的第一层过滤：主板、非ST、非退市、未停牌，并按交易日换手率与成交额筛出可交易标的。双击行跳转K线图。',
        meta: '基础过滤'
      }
    }
  },
  {
    path: '/short-term/pct-chg-distribution',
    name: 'short-term-pct-chg-distribution',
    component: ShortTermPctChgDistributionView,
    meta: {
      title: '涨幅分布',
      nav: true,
      navOrder: 61,
      group: '短线选股策略',
      hero: {
        number: '5.2',
        section: '短线选股策略',
        title: '涨幅分布',
        description: '沿用短线基础池过滤条件，按涨幅每 1% 一个区间统计股票数量。',
        meta: '分布观察'
      }
    }
  },
  {
    path: '/short-term',
    redirect: '/short-term/base-pool'
  },
  {
    path: '/volatility/universe',
    name: 'volatility-universe',
    component: VolatilityUniverseView,
    meta: {
      title: '第一层股票',
      nav: true,
      navOrder: 62,
      group: '波动策略',
      hero: {
        number: '7.1',
        section: '波动策略',
        title: '第一层股票',
        description: '沪深主板、非 ST 的全部股票。指定观察区间后双击股票，在 K 线上查看该区间的价格极值。',
        meta: '股票范围'
      }
    }
  },
  {
    // 旧地址仍可能留在浏览器历史中；统一回到股票范围页内勾选过滤。
    path: '/volatility/layer-3',
    redirect: to => ({ path: '/volatility/universe', query: to.query })
  },
  {
    path: '/volatility',
    redirect: '/volatility/universe'
  },
  {
    path: '/sync-jobs',
    name: 'sync-jobs',
    component: SyncJobLogView,
    meta: {
      title: '同步任务',
      nav: true,
      navOrder: 90,
      section: '系统',
      hero: {
        number: '13',
        section: '系统管理',
        description: '查看定时任务和手动任务的最近执行记录及状态统计。',
        meta: '任务日志'
      }
    }
  },
  {
    path: '/system-logs',
    name: 'system-logs',
    component: SystemLogView,
    meta: {
      title: '系统日志',
      nav: true,
      navOrder: 91,
      section: '系统',
      hero: {
        number: '14',
        section: '系统管理',
        description: '查看系统错误、操作审计及同步任务最新状态。',
        meta: '日志中心'
      }
    }
  },
  {
    path: '/kline/:symbol',
    name: 'stock-kline',
    component: StockKLineView,
    meta: { title: 'K线图' }
  },
  {
    path: '/trend-channel/:symbol',
    name: 'trend-channel',
    component: TrendChannelView,
    meta: { title: '动态边界' }
  },
  {
    path: '/financial/:symbol',
    name: 'stock-financial',
    component: StockFinancialView,
    meta: { title: '财务分析' }
  },
  {
    path: '/agent',
    name: 'agent',
    component: AgentView,
    meta: {
      title: 'AI Agent',
      nav: true,
      navOrder: 100,
      section: '智能助手',
      hero: {
        number: '15',
        section: '智能助手'
      }
    }
  },
  {
    path: '/boards',
    name: 'board-list',
    component: BoardListView,
    meta: {
      title: '板块 / ETF',
      nav: true,
      navOrder: 35,
      section: '市场数据',
      hero: {
        number: '9',
        section: '市场数据',
        meta: '板块索引'
      }
    }
  },
  {
    path: '/boards/:code',
    name: 'board-detail',
    component: BoardDetailView,
    meta: { title: '板块详情' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const inWorkspace = getItem('workspace') === '1'
  if (!inWorkspace && to.path !== '/') {
    next('/')
    return
  }
  next()
})

router.afterEach((to) => {
  const title = to.meta?.title || 'Seele'
  document.title = `${title} · Seele`
})

export default router
